import * as React from 'react';

export const WithHover = <T extends object>(Component: React.ComponentType<T>) => {
  const WithHoverContainer = (props: Omit<T, 'isHovered'>): React.JSX.Element => {
    const [isHovered, setHovered] = React.useState(false);

    const mouseOver = React.useCallback(() => setHovered(true), []);
    const mouseOut = React.useCallback(() => setHovered(false), []);

    return (
      <div onMouseOver={mouseOver} onMouseLeave={mouseOut}>
        <Component {...(props as T)} isHovered={isHovered} />
      </div>
    );
  };

  return WithHoverContainer;
};
